import { render, staticRenderFns } from "./document-editor.vue?vue&type=template&id=9bebd81c"
import script from "./document-editor.vue?vue&type=script&lang=js"
export * from "./document-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports